import React, { Component } from 'react';

export default class UnClickableScreenReader extends Component {
  render() {
    const { text } = this.props;
    return (
      <span
        style={{
          position: 'absolute',
          width: 1,
          height: 1,
          display: 'inline-block'
        }}
      >
        <a
          style={{
            display: 'inline-block',
            position: 'absolute',
            top: 0,
            left: 0,
            width: 1,
            height: 1,
            overflow: 'hidden',
            cursor: 'auto',
            color: 'white'
          }}
          href="javascript:void(0)"
        >
          {`${text}.    `}
        </a>
      </span>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/ScreenReader/UnClickableScreenReader.js